import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser'

export default defineNuxtPlugin((nuxtApp) => {
  console.info('Loading CIO...')

  const {
    CIO_WRITE_KEY
  } = nuxtApp.$config.public

  if (!CIO_WRITE_KEY) {
    console.info('CIO_WRITE_KEY not defined')
    return
  }

  const cio = AnalyticsBrowser.load(
    { writeKey: CIO_WRITE_KEY }
  )

  console.log('CIO loaded')

  return {
    provide: {
      cio
    }
  }
})
